import {motion} from "framer-motion";
import "./PrivateArea.scss";
import React, {useEffect} from 'react';
import {Link} from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faLongArrowAltLeft} from '@fortawesome/free-solid-svg-icons';
import './../config';
import axios from "axios";
import Login from "../components/Login";


const PrivateArea = (props) => {
    // const {params} = props.match;
    // console.log(params.id);

    useEffect(() => {
        axios.get(`https://jsonplaceholder.typicode.com/users`)
            .then(res => {
                console.log('OK', res);
            })
    }, []);

    const login = (data) => {
        // TODO
    };

    return (
        <motion.div initial='initial' animate='animate' exit={{opacity: 0}}>
            <div className='fullscreen'>
                <div className="toolbar__private_area" role="banner">
                    <div className="toolbar__private_area__left">
                        <img
                            width="30"
                            alt="Logo"
                            src={require('./../assets/images/logo.png')}
                        />
                        <h1>StudioSignorello</h1>
                    </div>
                    <div className="toolbar__private_area__right">
                        {/*<app-loader class="loader"></app-loader>*/}
                    </div>
                </div>
                <Login login={login}/>
            </div>
        </motion.div>
    )
};

export default PrivateArea;
